import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import {
  Container,
  Segment,
  Form,
  Header,
  Button,
  Icon,
  Grid,
  Dropdown,
  Label,
} from "semantic-ui-react";
import Alerta from "../components/Alertas";
import useObtenerProveedor from "../hooks/useObtenerProveedor";
import EditarProveedor from "../firebase/EditarProveedorDb";
import { auth } from "../firebase/firebaseConfig";

const categoriasProveedor = [

  {
    key: "st_externo",
    value: "ST_EXTERNO",
    text: "Servicio Técnico Externo",
    icon: "wrench",
    description: "Servicio técnico externo",
  },
  {
    key: "proveedor_equipos",
    value: "PROVEEDOR_EQUIPOS",
    text: "Proveedor de Equipos",
    icon: "box",
    description: "Venta de equipos médicos",
  },
  {
    key: "arriendo",
    value: "ARRIENDO",
    text: "Arriendo",
    icon: "clipboard outline",
    description: "Arriendo de equipos",
  },
  {
    key: "transporte",
    value: "TRANSPORTE",
    text: "Transporte",
    icon: "truck",
    description: "Transportistas y courier",
  },
  
  {
    key: "mantencion",
    value: "MANTENCION",
    text: "Mantención",
    icon: "settings",
    description: "Empresas de mantención",
  },
  {
    key: "insumos",
    value: "INSUMOS",
    text: "Insumos",
    icon: "archive",
    description: "Insumos y consumibles",
  },
  {
    key: "otros",
    value: "OTROS",
    text: "Otros",
    icon: "ellipsis horizontal",
    description: "Otros proveedores",
  },
];

const getCategoriaLabel = (categoria) => {
  const estilos = {
    ST_INTERNO: {
      color: "teal",
      icon: "wrench",
      text: "Servicio Técnico Interno",
    },
    ST_EXTERNO: {
      color: "blue",
      icon: "wrench",
      text: "Servicio Técnico Externo",
    },
    PROVEEDOR_EQUIPOS: {
      color: "violet",
      icon: "box",
      text: "Proveedor de Equipos",
    },
    ARRIENDO: {
      color: "orange",
      icon: "clipboard outline",
      text: "Arriendo",
    },
    TRANSPORTE: {
      color: "green",
      icon: "truck",
      text: "Transporte",
    },
    CALIBRACION: {
      color: "yellow",
      icon: "dashboard",
      text: "Calibración",
    },
    MANTENCION: {
      color: "pink",
      icon: "settings",
      text: "Mantención",
    },
    INSUMOS: {
      color: "grey",
      icon: "archive",
      text: "Insumos",
    },
    OTROS: {
      color: "grey",
      icon: "ellipsis horizontal",
      text: "Otros",
    },
  };

  const item = estilos[categoria] || estilos.OTROS;

  return (
    <Label color={item.color} basic style={{ borderRadius: 20 }}>
      <Icon name={item.icon} />
      {item.text}
    </Label>
  );
};

const ActualizaProveedor = () => {
  const user = auth.currentUser;
  const navigate = useNavigate();
  const { id } = useParams();
  const [proveedor] = useObtenerProveedor(id);

  const [alerta, cambiarAlerta] = useState({});
  const [estadoAlerta, cambiarEstadoAlerta] = useState(false);

  const [rut, setRut] = useState("");
  const [entidad, setEntidad] = useState("");
  const [direccion, setDireccion] = useState("");
  const [telefono, setTelefono] = useState("");
  const [correo, setCorreo] = useState("");
  const [nomContacto, setNomContacto] = useState("");
  const [categoria, setCategoria] = useState("");
  const [activo, setActivo] = useState(true);

  const [isSaving, setIsSaving] = useState(false);

  const volver = () => {
    navigate("/proveedores");
  };

  useEffect(() => {
    if (proveedor) {
      setRut(proveedor.rut || "");
      setEntidad(proveedor.nombre || "");
      setDireccion(proveedor.direccion || "");
      setTelefono(proveedor.telefono || "");
      setCorreo(proveedor.correo || "");
      setNomContacto(proveedor.contacto || "");
      setCategoria(proveedor.categoria || "");
      setActivo(proveedor.activo !== false);
    }
  }, [proveedor]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    cambiarEstadoAlerta(false);
    cambiarAlerta({});

    const expresionRegular =
      /[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+/;

    if (rut === "") {
      cambiarEstadoAlerta(true);
      cambiarAlerta({
        tipo: "error",
        mensaje: "Campo Rut no puede estar vacío",
      });
      return;
    }

    if (entidad === "") {
      cambiarEstadoAlerta(true);
      cambiarAlerta({
        tipo: "error",
        mensaje: "Campo Razón Social no puede estar vacío",
      });
      return;
    }

    if (direccion === "") {
      cambiarEstadoAlerta(true);
      cambiarAlerta({
        tipo: "error",
        mensaje: "Campo Dirección no puede estar vacío",
      });
      return;
    }

    if (telefono === "") {
      cambiarEstadoAlerta(true);
      cambiarAlerta({
        tipo: "error",
        mensaje: "Campo Teléfono no puede estar vacío",
      });
      return;
    }

    if (!expresionRegular.test(correo)) {
      cambiarEstadoAlerta(true);
      cambiarAlerta({
        tipo: "error",
        mensaje: "Favor ingresar un correo válido",
      });
      return;
    }

    if (nomContacto === "") {
      cambiarEstadoAlerta(true);
      cambiarAlerta({
        tipo: "error",
        mensaje: "Campo Contacto no puede estar vacío",
      });
      return;
    }

    if (categoria === "") {
      cambiarEstadoAlerta(true);
      cambiarAlerta({
        tipo: "error",
        mensaje: "Debe seleccionar una categoría",
      });
      return;
    }

    try {
      setIsSaving(true);

      await EditarProveedor({
        id,
        nombre: entidad.toLocaleUpperCase().trim(),
        direccion: direccion.toLocaleUpperCase().trim(),
        telefono: telefono.trim(),
        correo: correo.toLocaleLowerCase().trim(),
        contacto: nomContacto.toLocaleUpperCase().trim(),
        categoria,
        activo,      
        userMod: user?.email || "",
        fechaMod: new Date(),
      });

      cambiarEstadoAlerta(true);
      cambiarAlerta({
        tipo: "exito",
        mensaje: "Proveedor actualizado exitosamente",
      });
    } catch (error) {
      console.log("Se produjo un error al actualizar", error);
      cambiarEstadoAlerta(true);
      cambiarAlerta({
        tipo: "error",
        mensaje: "Error al actualizar proveedor",
      });
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <Container fluid style={{ padding: "24px" }}>
      <Segment
        raised
        style={{
          borderRadius: 18,
          border: "1px solid #e5e7eb",
          boxShadow: "0 14px 35px rgba(15, 23, 42, 0.08)",
          padding: 28,
        }}
      >
        <Header as="h2" style={{ marginBottom: 4 }}>
          <Icon name="edit outline" color="teal" />
          <Header.Content>
            Actualizar Proveedor
            <Header.Subheader>
              Modifica los datos comerciales, contacto y categoría del proveedor
            </Header.Subheader>
          </Header.Content>
        </Header>

        <Segment
          padded
          style={{
            marginTop: 24,
            borderRadius: 16,
            border: "1px solid #e5e7eb",
            background: "#ffffff",
          }}
        >
          <Form size="small" onSubmit={handleSubmit}>
            <Grid stackable columns={5}>
              <Grid.Column>
                <Form.Input
                  label="Rut"
                  readOnly
                  fluid
                  icon="address card"
                  iconPosition="left"
                  placeholder="Ingrese Rut"
                  value={rut}
                  onChange={(e) => setRut(e.target.value)}
                />
              </Grid.Column>

              <Grid.Column>
                <Form.Input
                  label="Razón Social"
                  readOnly
                  fluid
                  icon="user"
                  iconPosition="left"
                  placeholder="Ingrese Razón Social"
                  value={entidad}
                  onChange={(e) => setEntidad(e.target.value)}
                />
              </Grid.Column>

              <Grid.Column>
                <Form.Input
                  label="Dirección"
                  fluid
                  icon="address book outline"
                  iconPosition="left"
                  placeholder="Ingrese Dirección"
                  value={direccion}
                  onChange={(e) => setDireccion(e.target.value)}
                />
              </Grid.Column>

              <Grid.Column>
                <Form.Input
                  label="Teléfono"
                  fluid
                  icon="phone"
                  iconPosition="left"
                  placeholder="Ingrese Teléfono"
                  value={telefono}
                  onChange={(e) => setTelefono(e.target.value)}
                />
              </Grid.Column>

              <Grid.Column>
                <Form.Input
                  label="Email"
                  fluid
                  icon="mail"
                  iconPosition="left"
                  placeholder="Ingrese Email"
                  value={correo}
                  onChange={(e) => setCorreo(e.target.value)}
                />
              </Grid.Column>
            </Grid>

            <Grid stackable columns={4} style={{ marginTop: 4 }}>
              <Grid.Column width={5}>
                <Form.Field>
                  <label>Categoría</label>
                  <Dropdown
                    fluid
                    selection
                    search
                    clearable
                    placeholder="Seleccione una categoría"
                    options={categoriasProveedor}
                    value={categoria}
                    onChange={(e, { value }) => setCategoria(value)}
                  />
                </Form.Field>
              </Grid.Column>

              <Grid.Column width={6}>
                <Form.Input
                  label="Contacto"
                  fluid
                  icon="user"
                  iconPosition="left"
                  placeholder="Ingrese Nombre de Contacto"
                  value={nomContacto}
                  onChange={(e) => setNomContacto(e.target.value)}
                />
              </Grid.Column>

              <Grid.Column width={2}>
                <Form.Checkbox
                  label="Activo"
                  checked={activo}
                  onChange={(e, { checked }) => setActivo(checked)}
                  style={{ marginTop: 30 }}
                />
              </Grid.Column>

              <Grid.Column width={3}>
                <label style={{ display: "block", marginBottom: 6 }}>
                  Categoría actual
                </label>
                {getCategoriaLabel(categoria)}
              </Grid.Column>
            </Grid>

            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                gap: 10,
                flexWrap: "wrap",
                marginTop: 30,
              }}
            >
              <Button
                type="button"
                basic
                color="blue"
                onClick={volver}
                disabled={isSaving}
                style={{ borderRadius: 8 }}
              >
                <Icon name="arrow left" />
                Volver
              </Button>

              <Button
                color="teal"
                type="submit"
                loading={isSaving}
                disabled={isSaving}
                style={{
                  borderRadius: 8,
                  fontWeight: 700,
                }}
              >
                <Icon name="save" />
                Actualizar
              </Button>
            </div>
          </Form>
        </Segment>

        <Segment
          style={{
            marginTop: 18,
            borderRadius: 16,
            border: "none",
            background: "linear-gradient(to right, #ecfdf5, #f8fafc)",
            padding: "18px 22px",
          }}
        >
          <div style={{ display: "flex", alignItems: "center", gap: 14 }}>
            <Icon name="info circle" color="teal" size="large" />
            <div style={{ color: "#475569", fontSize: 14 }}>
              Si seleccionas <b>Servicio Técnico Interno</b>, el sistema marcará
              automáticamente este proveedor como <b>es_st_logisticmed</b>.
            </div>
          </div>
        </Segment>
      </Segment>

      <Alerta
        tipo={alerta.tipo}
        mensaje={alerta.mensaje}
        estadoAlerta={estadoAlerta}
        cambiarEstadoAlerta={cambiarEstadoAlerta}
      />
    </Container>
  );
};

export default ActualizaProveedor;